const scriptElement = document.createElement('script')
scriptElement.src = process.env.VUE_APP_API_DOMAIN+'consent/cookie.js'
scriptElement.setAttribute('cmp-taxid', '4325231680168')
scriptElement.setAttribute('cmp-secret-id', '4cNfw2789ilcn8Sy62RMVJMiwaFbr1iIIoNTc9Yu12I.eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJIb3N0bmFtZSI6Imh0dHBzOi8vdWF0Y21wLm9uZS50aC90ZXN0LXdlYnNjcmlwdCIsIlNlcnZpY2VJZCI6IkNNUC1BNjg5LTE2ODYyMTk1NzM0NzgifQTGgdpJIi2NNd6CnbbVRrCieiaDVdSoo4')
scriptElement.setAttribute('cmp-branchid', '00000')
scriptElement.setAttribute('cmp-service-id', 'CMP-A689-1686219573478')
scriptElement.setAttribute('cmp-policy-id', '71b27e7a-0c23-4fd9-87ab-593fd1457177')
scriptElement.setAttribute('cmp-consent-id', '82f93bb2-96b6-4601-b98f-9c5e92e5ba60')
scriptElement.setAttribute('cmp-session-id', generateRandomNumber())
scriptElement.setAttribute('cmp-ipaddress', '')
scriptElement.setAttribute('cmp-account-id', '')

function generateRandomNumber () {
  const min = 1000000000
  const max = 9999999999
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export default scriptElement
